import React from "react";

import "./Hero.css";

export default function Hero() {
  return (
    <div className="row gx-5 gy-5 justify-content-center">
      <div className="col col-lg-9">
        <h4>Hi, My name is</h4>
        <h1>Anne Helene Nergård</h1>
        <h2>I am an Frontend developer</h2>
        <h3>
          UX-Designer with a heart for front-end. Bridging the gap between
          design and code, I bring digital ideas to life with a perfect fusion
          of aesthetics and functionality
        </h3>
      </div>
    </div>
  );
}
